exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".template-download-button{color:#007bff}\n", "", {"version":3,"sources":["D:/a/1/s/ContainerWeb.WebApp/src/components/routeOptimalizationWizard/D:/a/1/s/ContainerWeb.WebApp/src/components/routeOptimalizationWizard/D:/a/1/s/ContainerWeb.WebApp/src/components/routeOptimalizationWizard/templateDownloadButton.scss"],"names":[],"mappings":"AAAA,0BACE,aAAc,CAAA","file":"templateDownloadButton.scss","sourcesContent":[".template-download-button {\r\n  color: #007bff;\r\n}\r\n"],"sourceRoot":""}]);

// exports
